import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../Component/img/logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl"; // Adjust the path as needed
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify"; // Import toast notifications
import "react-toastify/dist/ReactToastify.css";  // Import styles for toast

const VisitorLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  const [emailDisabled, setEmailDisabled] = useState(false);

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleEmailCheck = async (e) => {
    e.preventDefault();
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      toast.error("Please enter a valid email address."); // Display error toast
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}check-email/${email}`);
      if (response.status === 200) {
        setEmailChecked(true);
        setEmailDisabled(true);
        setError("");
      } else {
        setEmailChecked(false);
        setError("Email does not exist.");
        toast.error("Email does not exist."); // Display error toast
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setError("Account not found. Please try signing up.");
        toast.error("Account not found. Please try signing up."); // Display error toast
      } else {
        console.error("Email check error:", error);
        setError("Error checking email. Please try again.");
        toast.error("Error checking email. Please try again."); // Display error toast
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please enter email and password.");
      toast.error("Please enter email and password."); // Display error toast
      return;
    }

    setLoading(true);
    setTimeout(async () => {
      try {
        const response = await axios.post(`${BASE_URL}login-visitor`, {
          email,
          password,
        });

        if (response.status === 200 && response.data) {
          const { visitor_id, visitor_name, visitor_email } = response.data;
          if (visitor_id && visitor_name && visitor_email) {
            localStorage.setItem("visitor_id", visitor_id);
            localStorage.setItem("visitor_name", visitor_name);
            localStorage.setItem("visitor_email", visitor_email);
            setError("");
            toast.success("Login successful!"); // Display success toast

            const redirectUrl = localStorage.getItem("redirectUrl");
            if (
              redirectUrl &&
              (redirectUrl.startsWith("http://") ||
                redirectUrl.startsWith("https://"))
            ) {
              window.location.href = redirectUrl;
            } else {
              navigate("/");
            }

            localStorage.removeItem("redirectUrl");
          } else {
            console.error("Login failed: No visitor data received.");
            setError("Login failed: No visitor data received.");
            toast.error("Login failed: No visitor data received."); // Display error toast
          }
        }
      } catch (error) {
        console.error("Login error:", error);
        setError(error.response?.data?.message || "An error occurred while logging in.");
        toast.error(error.response?.data?.message || "An error occurred while logging in."); // Display error toast
      } finally {
        setLoading(false);
      }
    }, 50);
  };

  const handleGoogleSignIn = async (credentialResponse) => {
    const { credential } = credentialResponse;

    try {
      const response = await axios.post(`${BASE_URL}auth/google-login`, {
        tokenId: credential,
      });

      if (response.status === 200 && response.data) {
        const { visitor_id, visitor_name, visitor_email } = response.data.visitor;

        if (visitor_id && visitor_name && visitor_email) {
          localStorage.setItem("visitor_id", visitor_id);
          localStorage.setItem("visitor_name", visitor_name);
          localStorage.setItem("visitor_email", visitor_email);
          setError("");
          toast.success("Google Sign-In successful!"); // Display success toast

          const redirectUrl = localStorage.getItem("redirectUrl");
          if (
            redirectUrl &&
            (redirectUrl.startsWith("http://") ||
              redirectUrl.startsWith("https://"))
          ) {
            window.location.href = redirectUrl;
          } else {
            navigate("/");
          }

          localStorage.removeItem("redirectUrl");
        } else {
          console.error("Login failed: No visitor data received.");
          setError("Login failed: No visitor data received.");
          toast.error("Login failed: No visitor data received."); // Display error toast
        }
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      setError("Google Sign-In failed. Please try again.");
      toast.error("Google Sign-In failed. Please try again."); // Display error toast
    }
  };

  return (
    <GoogleOAuthProvider clientId="1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com">
      <div className="vh-100 bg-salt align-content-center text-center">
        <div className="row justify-content-center">
          <div className="col-md-4 align-content-center text-start bg-white">
            <div className="text-center mb-4 mt-2">
              <img src={logo} alt="" className="img-fluid logocls" />
            </div>

            <div className="lgindvcon p-4">
              <div className="mt-1 text-center">
                <button 
                    className="google-signin-btn" 
                    onClick={() => {
                        window.google?.accounts.id.initialize({
                            client_id: "1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com",
                            callback: handleGoogleSignIn,
                        });
                        window.google?.accounts.id.prompt();
                    }}
                >
                    <FontAwesomeIcon icon={faGoogle} /> Sign in with Google
                </button>
              </div>
              <hr />
              <h3>LogIn</h3>
              <form onSubmit={handleEmailCheck}>
                <div className="mb-2">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="forminput"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Email ..."
                    required
                    disabled={emailDisabled}
                  />
                </div>
                {!emailChecked && (
                  <button type="submit" className="btnn" disabled={loading}>
                    {loading ? "Checking Email..." : "Continue"}
                  </button>
                )}
              </form>

              {emailChecked && (
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="forminput"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password Here.."
                      required
                    />
                  </div>
                  <div className="mb-2 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input "
                      id="showPassword"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)}
                    />
                    <label className="form-check-label" htmlFor="showPassword">
                      Show Password
                    </label>
                  </div>
                  <button type="submit" className="btnn" disabled={loading}>
                    {loading ? "Logging..." : "Login"}
                  </button>
                </form>
              )}

              <div className="mt-2">
                <small>
                  <span className="form-label text-muted">
                    Don't Have An Account?
                  </span>{" "}
                  <Link to="/register" className="text-muted">
                    Create Account
                  </Link>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer /> {/* Toast container for displaying toasts */}
    </GoogleOAuthProvider>
  );
};

export default VisitorLogin;
